import image from 'shared/assets/images/integrationsSliders/capsule/capsule.png'
import { LINK_AMPERSAND_INTEGRATION_GUIDE } from 'shared/constants/links'
import { type IntegrationDetailsData } from 'entities/Integrations/lib/integrationsDescription'

export const capsule: IntegrationDetailsData = {
  subheadline: 'Strengthen your simple CRM with comprehensive messaging capabilities.',
  overview:
    'Connect Salesmsg with Capsule to streamline your workflow and keep your CRM data up to date. When you engage with contacts through Salesmsg, relevant information flows to Capsule, ensuring your records stay current without manual data entry.',
  keyBenefits: [
    'Quick setup through the Salesmsg App Marketplace',
    'Reduce manual data entry and improve workflow efficiency',
    'Seamless integration between your messaging and CRM workflows',
  ],
  images: [image],
  docs: LINK_AMPERSAND_INTEGRATION_GUIDE,
}
